import { validateBalance } from './balance/validate'
import { validateSeaPassages } from './sea-passages'

export { ContentValidationError } from './errors'
export { CONTENT_HASH } from './hash'
export {
  ALL_CITIES,
  COUNTRIES,
  LAND_MASK,
  LandMask,
  MIN_CITIES_PER_BELLIGERENT,
  PLAYABLE_COUNTRIES,
  WORLD_NETWORK_CANDIDATES,
  type City,
  type CityId,
  type Country,
  type CountryCode,
} from './geo'
export { OCEAN_CROSSINGS, WORLD_OCEAN_CROSSING_LEGS, type CityRef, type OceanCrossing } from './ocean-crossings'
export { SEA_PASSAGES, type SeaPassage } from './sea-passages'
export * from './balance/keys'
export * from './balance/tables'

validateBalance()
validateSeaPassages()
